import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { Observable } from 'rxjs';
import { INoItemsOptions } from '../../../feed/feed.interface';
import { Notification } from '../../../notification-data/notification.model';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';

@Component({
  selector: 'app-notifications-list',
  templateUrl: './notifications-list.component.html',
  styleUrls: ['./notifications-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsListComponent implements OnInit {
  @Input() notifications$: Observable<List<Notification>>;
  @Input() trackingScreenName: TrackingScreenNamesEnum;
  @Input() showLegacyNotificationItem = false; // remove this once we're done with IA nav experiment

  @Output()
  onClickNotification: EventEmitter<Notification> = new EventEmitter<Notification>();
  @Output()
  onDismissNotification: EventEmitter<Notification> = new EventEmitter<Notification>();

  noNotificationsOptions: INoItemsOptions;

  constructor(private _translateService: TranslateService) {}

  ngOnInit() {
    this.noNotificationsOptions = {
      iconName: 'notifications-empty-state',
      title: this._translateService.instant(
        'HOME.NOTIFICATIONS.EMPTY_STATE.TITLE'
      ),
      description: this._translateService.instant(
        'HOME.NOTIFICATIONS.EMPTY_STATE.DESCRIPTION'
      ),
    };
  }

  onClickItem(notification: Notification) {
    this.onClickNotification.emit(notification);
  }

  onDismissItem(notification: Notification) {
    this.onDismissNotification.emit(notification);
  }
}
